import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { UsuarioService } from '../../../../providers/usuario.service';
import { Usuario } from '../../../../interfaces/usuario';
import { verificarContraseñaValidatorFn } from '../../usuario/usuario.component';
import { FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../../providers/auth.service';

@Component({
  selector: 'app-cambiar-contrasena-dialog',
  templateUrl: './cambiar-contrasena-dialog.component.html',
  styleUrls: ['./cambiar-contrasena-dialog.component.scss']
})
export class CambiarContrasenaDialog implements OnInit {
  error: string = '';
  cargando: boolean = true;
  usuario: Usuario;
  hide: boolean;

  contrasenaActualFormControl = new FormControl('', [
    Validators.required
  ]);
  contrasenaFormControl = new FormControl('', []);
  contrasenaVerificadaFormControl = new FormControl('', []);

  constructor(
    public dialogCambiar: MatDialogRef<CambiarContrasenaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private usuarioService: UsuarioService,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.contrasenaFormControl.setValidators([
      verificarContraseñaValidatorFn(
        null,
        this.contrasenaFormControl,
        this.contrasenaVerificadaFormControl
      )
    ]);
    this.contrasenaVerificadaFormControl.setValidators([
      verificarContraseñaValidatorFn(
        null,
        this.contrasenaFormControl,
        this.contrasenaVerificadaFormControl
      )
    ]);

    this.usuario = new Usuario();
    this.usuario.usuario = this.authenticationService.usuario;
    this.usuario.email = this.authenticationService.email;
  }

  onInput(): void {
    this.error = '';
  }

  onContraseniaChange(): void {
    // al cambiar la contraseña verificar que sea igual a la verificada
    this.contrasenaFormControl.updateValueAndValidity();
    this.contrasenaFormControl.markAsTouched();
    this.contrasenaVerificadaFormControl.updateValueAndValidity();
    this.contrasenaVerificadaFormControl.markAsTouched();
  }

  onCancelar(): void {
    this.dialogCambiar.close();
  }

  onCambiar(): void {
    if (this.contrasenaFormControl.hasError('distintas') ||
      this.contrasenaVerificadaFormControl.hasError('required') ||
      this.contrasenaVerificadaFormControl.hasError('distintas') ||
      this.contrasenaActualFormControl.hasError('required')) {
      this.contrasenaFormControl.markAsTouched();
      this.contrasenaVerificadaFormControl.markAsTouched();
      this.contrasenaActualFormControl.markAsTouched();

      this.error = "Datos icorrectos";
    } else {
      this.usuarioService.cambiarContrasena(
        {
          contrasenaActual: this.contrasenaActualFormControl.value,
          contrasena: this.contrasenaFormControl.value,
          contrasena2: this.contrasenaVerificadaFormControl.value
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1) {
            this.snackBar.open(respuesta.mensaje, 'OK', { duration: null });
            this.dialogCambiar.close();
          } else {
            // error en el servidor
            this.error = respuesta.mensaje;
          }

          this.cargando = false;
        },
        error => {
          this.cargando = false;
          this.error = error;
        }
      );
    }
  }
}
